import React from 'react';
import MdCheckbox from 'react-icons/lib/md/check-box';
import MdCheckboxOutlineBlank  from 'react-icons/lib/md/check-box-outline-blank';
import Button from '../Button';

const style = props => ({
  display: 'block',
  width: 'auto',
  height: 'auto',
  minHeight: 48,

  paddingLeft: !!props.leftIcon ? 40 : 24,
  paddingRight: 40,

  boxShadow: 'none',

  textAlign: 'left',

  '& svg': {
    display: 'block',
    margin: '0 auto',
  },

  ...props.style,
});

class CheckboxButton extends React.PureComponent {
  render () {
    return (
      <Button
        {...this.props}
        style={style(this.props)}
        rightIcon={this.props.isChecked ? (<MdCheckbox size={24} />) : (<MdCheckboxOutlineBlank size={24} />)}
        iconOffsetLeft={this.props.leftIcon && 8}
        iconOffsetRight={8}
        isRaised={this.props.isChecked}
      />
    );
  }
}

export default CheckboxButton;




// WEBPACK FOOTER //
// ./src/components/ui/CheckboxButton/CheckboxButton.js